import styled, { keyframes } from 'styled-components';

const typingBounce = keyframes`
  0%, 80%, 100% {
    transform: translateY(0);
    opacity: 0.35;
  }
  40% {
    transform: translateY(-4px);
    opacity: 1;
  }
`;

const iconPulse = keyframes`
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 0 0 rgba(43, 106, 78, 0.35);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 0 0 6px rgba(43, 106, 78, 0);
  }
`;

export const Container = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;
  overflow: hidden;
  position: relative;

  .nucleo-badge {
    font-size: 13px;
    color: #718096;

    img {
      width: 18px;
      height: 18px;
      object-fit: contain;
    }
  }

  .greeting-title {
    font-size: 30px;
    font-weight: 600;
    color: #2a2a2a;
  }

  .subtitle {
    font-size: 18px;
    color: #2a2a2a;
  }

  .ia-disclaimer {
    max-width: 640px;
    font-size: 12px;
    line-height: 1.6;
    color: #718096;
    border: 1px solid #e9ecef;

    i {
      font-size: 16px;
      color: #a0aec0;
    }

    strong {
      font-weight: 600;
      color: #4a5568;
    }
  }
`;

export const ChatView = styled.div`
  flex: 1;
  min-height: 0;
  height: 100%;

  .pending-files {
    max-width: 780px;
    margin: 0 auto;
    gap: 8px;

    .pending-file {
      position: relative;
      background: #f7fafc;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 8px 28px 8px 8px;
      min-width: 220px;
      max-width: 280px;

      .file-icon {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        flex-shrink: 0;
        margin-right: 10px;

        i {
          font-size: 22px;
        }

        .spinner-border {
          width: 18px;
          height: 18px;
        }
      }

      .file-meta {
        min-width: 0;
        flex: 1;

        .file-name {
          font-size: 13px;
          color: #2a2a2a;
          max-width: 160px;
        }

        .file-type {
          font-size: 11px;
        }
      }

      .remove-file {
        position: absolute;
        top: 4px;
        right: 4px;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: #2a2a2a;
        color: #fff;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        padding: 0;

        i {
          font-size: 14px;
        }

        &:hover {
          background: #1a202c;
        }
      }

      &.in-context {
        background: #fff;
        border-style: dashed;

        .file-icon {
          opacity: 0.75;
        }
      }
    }
  }

  .composer-chips {
    max-width: 780px;
    margin: 0 auto;
    gap: 8px;

    .composer-chip {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      background: #eef7f1;
      color: #2b6a4e;
      border-radius: 999px;
      padding: 4px 10px;
      font-size: 12px;
      font-weight: 500;

      i {
        font-size: 14px;
      }

      button {
        border: none;
        background: none;
        padding: 0;
        display: inline-flex;
        color: inherit;
        opacity: 0.7;
        cursor: pointer;

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  .messages-list {
    overflow-y: auto;
    min-height: 0;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: #d1d5db;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #9ca3af;
    }
  }

  .messages-inner {
    max-width: 780px;

    .message {
      max-width: 75%;
      font-size: 14px;
      line-height: 1.5;
      word-wrap: break-word;
    }

    .message-user {
      background: #f0faf5;
      color: #2a2a2a;
      white-space: pre-wrap;
    }

    .message-assistant {
      color: #2a2a2a;
    }

    .assistant-block {
      max-width: 75%;
      min-width: 0;
      .message {
        max-width: 100%;
      }
    }

    .message-actions {
      .copy-button {
        justify-content: center;
        width: 26px;
        height: 26px;
        padding: 0;
        color: #a0aec0;
        background: transparent;
        border: none;
        border-radius: 6px;
        cursor: pointer;

        i {
          font-size: 16px;
        }

        &:hover:not(:disabled) {
          color: #2a2a2a;
          background: #f1f5f9;
        }

        &:disabled {
          cursor: default;
        }

        &.copied {
          color: #2b6a4e;
        }

        .spinner-border {
          width: 13px;
          height: 13px;
          border-width: 2px;
        }
      }
    }

    .message-error {
      background: #fff5f5;
      color: #c53030;
      border: 1px solid #fed7d7;
      font-size: 14px;

      i {
        font-size: 18px;
      }
    }
  }
`;

export const ChatTopBar = styled.div`
  padding-bottom: 8px;

  .topbar-inner {
    max-width: 780px;
    width: 100%;
  }

  .menu-button {
    color: #718096;

    i {
      font-size: 22px;
    }

    &:hover {
      color: #2a2a2a;
    }
  }
`;

export const MessageRow = styled.div``;

export const FileDropOverlay = styled.div`
  position: absolute;
  inset: 16px;
  background: rgba(43, 106, 78, 0.06);
  border: 2px dashed #2b6a4e;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
  pointer-events: none;

  .overlay-content {
    background: #fff;
    padding: 24px 36px;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);

    i {
      font-size: 48px;
      color: #2b6a4e;
      display: block;
    }

    div {
      font-size: 16px;
      color: #2a2a2a;
    }
  }
`;

export const MarkdownContent = styled.div`
  max-width: 100%;
  font-size: 14px;
  line-height: 1.6;
  color: #2a2a2a;

  p {
    margin-bottom: 0.75rem;

    &:last-child {
      margin-bottom: 0;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    font-weight: 600;
    margin-top: 1rem;
    margin-bottom: 0.5rem;
  }

  h1 {
    font-size: 1.25rem;
  }

  h2 {
    font-size: 1.15rem;
  }

  h3 {
    font-size: 1.05rem;
  }

  h4 {
    font-size: 1rem;
  }

  ul,
  ol {
    margin-bottom: 0.75rem;
    padding-left: 1.25rem;
  }

  li {
    margin-bottom: 0.25rem;
  }

  strong {
    font-weight: 700;
  }

  hr {
    border: 0;
    border-top: 1px solid #e2e8f0;
    margin: 1rem 0;
  }

  code {
    background: #edf2f7;
    padding: 1px 6px;
    border-radius: 4px;
    font-size: 0.9em;
    font-family: 'Courier New', monospace;
  }

  pre {
    background: #1a202c;
    color: #f7fafc;
    padding: 12px;
    border-radius: 6px;
    overflow-x: auto;
    margin-bottom: 0.75rem;

    code {
      background: none;
      color: inherit;
      padding: 0;
    }
  }

  blockquote {
    border-left: 3px solid #cbd5e0;
    padding-left: 12px;
    color: #4a5568;
    margin: 0.75rem 0;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 0.75rem 0;
    font-size: 13px;
  }

  th,
  td {
    border: 1px solid #e2e8f0;
    padding: 8px 10px;
    text-align: left;
    vertical-align: top;
  }

  thead {
    background: #f7fafc;
  }

  thead th {
    font-weight: 600;
  }

  tbody tr:nth-of-type(odd) {
    background: #fafbfc;
  }

  a {
    color: #2b6a4e;
    text-decoration: underline;
  }

  .code-block {
    margin-bottom: 0.75rem;

    code {
      background: none;
      padding: 0;
      font-family: 'Courier New', monospace;
    }
  }

  .table-scroll {
    max-width: 100%;
    overflow-x: auto;
    margin: 0.75rem 0;

    table {
      margin: 0;
    }
  }

  .katex-display {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .interrupted-note {
    color: #718096;
    font-style: italic;
  }

  .citations {
    border-top: 1px solid #e2e8f0;
    font-size: 13px;

    .citations-title {
      font-weight: 600;
      color: #4a5568;
    }

    li {
      margin-bottom: 0.15rem;
      word-break: break-word;
    }
  }
`;

export const GeneratedImage = styled.div`
  background: #f5f5f5;
  max-width: 75%;

  .generated-image {
    display: block;
    max-width: 100%;
    max-height: 420px;
    border-radius: 12px;
    object-fit: contain;
  }

  .download-image {
    margin-top: 6px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    color: #718096;
    background: none;
    border: none;
    border-radius: 8px;

    i {
      font-size: 20px;
    }

    &:hover {
      background: #ececec;
      color: #2a2a2a;
    }
  }
`;

export const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #cbd5e0;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  object-fit: cover;
  flex-shrink: 0;
`;

export const AssistantIcon = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #f0faf5;
  flex-shrink: 0;

  &.pulsing {
    animation: ${iconPulse} 1.6s infinite ease-in-out;
  }

  img {
    width: 18px;
    height: 18px;
    object-fit: contain;
  }
`;

export const TypingDots = styled.div`
  background: #f5f5f5;
  gap: 6px;

  .dots {
    display: inline-flex;
    align-items: center;
    gap: 4px;

    span {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #4a5568;
      display: inline-block;
      animation: ${typingBounce} 1.2s infinite ease-in-out;

      &:nth-child(2) {
        animation-delay: 0.15s;
      }

      &:nth-child(3) {
        animation-delay: 0.3s;
      }
    }
  }

  .status-text {
    font-size: 13px;
    color: #4a5568;
    font-style: italic;
  }
`;

export const ProviderDropdown = styled.div`
  position: relative;

  &.start-corner {
    position: absolute;
    top: 12px;
    left: 0;
    z-index: 5;
  }

  .dropdown-menu {
    min-width: 240px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 6px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .dropdown-item {
    border-radius: 6px;
    padding: 8px 12px;
    color: #2a2a2a;
    font-size: 14px;

    &.active,
    &:active {
      background: #f0faf5;
      color: #2a2a2a;
    }

    &:hover {
      background: #f7fafc;
    }
  }
`;

export const ProviderHeader = styled.button`
  font-size: 16px;
  color: #4a5568;

  &:hover {
    background: #f7fafc;
  }

  img {
    width: 22px;
    height: 22px;
    object-fit: contain;
  }

  i {
    font-size: 18px;
    color: #718096;
  }
`;

export const ChatInputBar = styled.div`
  border: 1px solid #e2e8f0;
  max-width: 780px;
  margin: 0 auto;

  input {
    font-size: 15px;
    color: #2a2a2a;

    &::placeholder {
      color: #a0aec0;
    }
  }

  .composer-textarea {
    font-size: 15px;
    color: #2a2a2a;
    resize: none;
    line-height: 1.4;
    max-height: 160px;
    overflow-y: auto;
    padding: 6px 0;
    align-self: center;

    &::placeholder {
      color: #a0aec0;
    }
  }

  .attach-button {
    color: #718096;

    i {
      font-size: 20px;
    }

    &:hover {
      color: #4a5568;
    }
  }

  .mic-button {
    width: 36px;
    height: 36px;
    background: #f1f3f5;
    color: #495057;
    margin-right: 6px;
    flex-shrink: 0;

    i {
      font-size: 18px;
    }

    &:not(:disabled):hover {
      background: #e9ecef;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    &.listening {
      background: #ea4335;
      color: #fff;
    }
  }

  .send-button {
    width: 36px;
    height: 36px;
    background: #1a202c;
    color: #fff;

    i {
      font-size: 18px;
    }

    &:disabled {
      opacity: 0.4;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: #2d3748;
    }
  }

  .stop-button {
    background: #2b6a4e;

    &:hover {
      background: #1f5a40;
    }
  }
`;
